import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'; // ✅ añade esto
import { environment } from '../../../../environments/environment';

@Component({
  selector: "app-formulario-sucursal",
  templateUrl: "./formulario.component.html"

})
export class FormularioComponent implements OnInit {
  dato: FormGroup;
  tab = 0;
  tab2 = [];
  form_documentos_estructuras;
  form_estructuras_contenidos;
  CkeditorConfig = {
    height: document.body.clientHeight - 460
  };



  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer  // ✅ inyectamos el sanitizer
  ) {}

  ngOnInit() {
    this.tab2[0] = 0;
    this.dato = this.fb.group({
      id: [''],
      nombre: ["", [Validators.required]],
      activo: [true],
      tipo_documento: ["", [Validators.required]],
      tipo_rvoe: ["", [Validators.required]],
      niveles_educativos_id: ["", [Validators.required]],
      documentos_estructuras: this.fb.array([])
    });

    this.form_documentos_estructuras = {
      id: [""],
      documentos_id: [""],
      tipo: ["", [Validators.required]],
      filas: ["", [Validators.required]],
      columnas: ["", [Validators.required]],
      estructuras_contenidos: this.fb.array([])
    };

    this.form_estructuras_contenidos = {
      id: [""],
      estructuras_id: [""],
      fila: ["", [Validators.required]],
      columna: ["", [Validators.required]],
      ancho_porcentaje: ["", [Validators.required]],
      alto_porcentaje: ["", [Validators.required]],
      contenido: [""],
      path_imagen: [""],
      tipo: ["CONTENIDO"]
    };

    document.getElementById("catalogos").click();
  }

  //// ✅ Función que convierte una cadena base64 a URL segura
  /*
  safeImage(base64: string): SafeUrl {
    if (!base64) return './assets/128x128.png';
    return this.sanitizer.bypassSecurityTrustUrl('data:image/jpeg;base64,' + base64);
  }*/

   safeImage(base64: string): SafeUrl {
     console.log(
  'safeImage() recibido:',
  typeof base64 === 'string' ? base64.substring(0, 100) : base64
);
    if (!base64) {
      console.log('------------------>>>>>>>> IMAGEN NO BASE 64');
      return './assets/128x128.png';
    }

    try {
            console.log('------------------>>>>>>>> IMAGEN CONSEGUIDA OK EN BASE 64');

      return this.sanitizer.bypassSecurityTrustUrl('data:image/jpeg;base64,' + base64);
    } catch (e) {
      console.error('Error al sanitizar imagen:', e);
      return './assets/128x128.png';
    }
  }

}





/*import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { environment } from '../../../../environments/environment';

@Component({
  selector: "app-formulario-sucursal",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tab = 0;
  tab2 = [];
  form_documentos_estructuras;
  form_estructuras_contenidos;
  CkeditorConfig = {
    height: document.body.clientHeight - 460
  };
  constructor(private fb: FormBuilder) {}
    
  ngOnInit() {
    this.tab2[0] = 0;
    this.dato = this.fb.group({
      id: [''],
      nombre: ["", [Validators.required]],
      activo: [true],
      tipo_documento: ["", [Validators.required]], /// updated joram
      tipo_rvoe: ["", [Validators.required]], /// updated joram
      niveles_educativos_id: ["", [Validators.required]], /// updated joram
      documentos_estructuras: this.fb.array([])
    });

    this.form_documentos_estructuras = {
      id: [""],
      documentos_id: [""],
      tipo: ["", [Validators.required]],
      filas: ["", [Validators.required]],
      columnas: ["", [Validators.required]],
      estructuras_contenidos: this.fb.array([])
    };

    this.form_estructuras_contenidos = {
      id: [""],
      estructuras_id: [""],
      fila: ["", [Validators.required]],
      columna: ["", [Validators.required]],
      ancho_porcentaje: ["", [Validators.required]],
      alto_porcentaje: ["", [Validators.required]],
      contenido: [""],
      path_imagen: [""],
      tipo: ["CONTENIDO"]
    };

    document.getElementById("catalogos").click();
  }
}
*/


